import React, { useState, useEffect } from 'react'
import './ContentExpositor.scss'
import { DobleGuion } from '../components/DobleGuion';
import Separator from '../components/Separator';
import { ProductoExpositorLinea } from '../components/ProductoExpositorLinea'
import { ProductoImplantacionLinea } from './ProductoImplantacionLinea';

const ContentExpositor = ({ productsExpositor, clickProductSelected, productType='expositor', setProductsInImplantationAll=() =>{}, setTotalPrice=() =>{} }) => {

    const [showMoreLess, setShowMoreLess] = useState(null)
    const [productsInExpositorAll, setProductsInExpositorAll] = useState([])
    const [productsInExpositorLimit, setProductsInExpositorLimit] = useState([])
    const [productsInExpositorShow, setProductsInExpositorShow] = useState([])

    useEffect(() => {
        setProductsInExpositorShow(productsExpositor.slice(0, 5))
        setProductsInExpositorAll(productsExpositor)
        setProductsInExpositorLimit(productsExpositor.slice(0, 5))
        setShowMoreLess(false)
        setProductsInImplantationAll(productsExpositor)
    }, [])

    useEffect(() => {
        if (showMoreLess) {
            setProductsInExpositorShow(productsInExpositorAll)
        } else {
            setProductsInExpositorShow(productsInExpositorLimit)
        }
    }, [showMoreLess])

    const handleClickShowMoreOrLess = () => {
        setShowMoreLess(!showMoreLess)
    }

    //Para implantaciones

    const handleClickQuantity = (accion, product) => {
      let cantidadAOperar = 1
      if(parseInt(product.product.UnidadesPack)){
        cantidadAOperar = parseInt(product.product.UnidadesPack)
      }else if(parseInt(product.product.UnidadesPallet)){
        cantidadAOperar = parseInt(product.product.UnidadesPallet)
      }
      if(accion == 'restar' && parseInt(product.quantity)>0){
        product.quantity = parseInt(product.quantity) - cantidadAOperar + ''
      }else if(accion == 'sumar'){
        product.quantity = parseInt(product.quantity) + cantidadAOperar + ''
      }

      for (let i = 0; i < productsInExpositorAll.length; i++) {
        const element = productsInExpositorAll[i];
        if(element.product.RefSuelto == product.product.RefSuelto){
          element.quantity = product.quantity
        }
        
      }
      setProductsInExpositorShow(productsInExpositorAll.slice(0, 5))
      setProductsInExpositorAll(productsInExpositorAll)
      setProductsInExpositorLimit(productsInExpositorAll.slice(0, 5))
      setProductsInImplantationAll(productsInExpositorAll)
      setTotalPrice();
    }

    //Fin para implantaciones

    return (
        <React.Fragment>
            <div className={showMoreLess ? "items-container mobile more" : "items-container mobile"}>
                {
                    productsInExpositorShow.map((item, index) => {
                        return (
                            <React.Fragment>
                                { (productType != 'implantacion' && item.product) ?
                                    item.product.Nombre.toLowerCase().indexOf('expositor') === -1 &&
                                    <div key={index} onClick={() => clickProductSelected(item)}>
                                        <ProductoExpositorLinea product={item}>{index}</ProductoExpositorLinea>
                                        <Separator />
                                    </div>
                                :
                                    <div key={index}>
                                        <ProductoImplantacionLinea handleClickQuantity={(operacion)=> handleClickQuantity(operacion, item)} product={item}>{index}</ProductoImplantacionLinea>
                                        <Separator />
                                    </div>
                                }
                            </React.Fragment>
                        )
                    })
                }
            </div>
            <div className="items-container desktop">
                {
                    productsInExpositorAll.map((item, index) => {
                        return (
                            <React.Fragment>
                                { productType != 'implantacion' ?
                                    item.product.Nombre.toLowerCase().indexOf('expositor') === -1 &&
                                    <div key={index} onClick={() => clickProductSelected(item)}>
                                        <ProductoExpositorLinea product={item}>{index}</ProductoExpositorLinea>
                                        <Separator />
                                    </div>
                                :
                                    <div key={index}>
                                        <ProductoImplantacionLinea handleClickQuantity={(operacion)=> handleClickQuantity(operacion, item)} product={item}>{index}</ProductoImplantacionLinea>
                                        <Separator />
                                    </div>
                                }
                            </React.Fragment>
                        )
                    })
                }
            </div>
            <div className="show-more">
                {!showMoreLess &&
                    <button className="btn" onClick={handleClickShowMoreOrLess}><p>+</p> VER TODOS LOS PRODUCTOS</button>
                }
                {showMoreLess &&
                    <button className="btn" onClick={handleClickShowMoreOrLess}><p>+</p> VER MENOS PRODUCTOS</button>
                }
            </div>
        </React.Fragment>
    )
}

export default ContentExpositor